import { useState } from 'react';
import { Tabs } from '@/components/ui';
import {
  WORDING_SECTIONS,
  type ConsentWording,
} from '@/features/consent-templates/types';
import {
  LANG_LABEL,
  SECTION_HEADING,
  type WordingLang,
} from './consent-format';
import styles from './ConsentTemplates.module.css';

const LANGS: WordingLang[] = ['en', 'ms'];

/**
 * The wording as the patient reads it in the app, in English or Bahasa
 * Melayu (the patient picks the language when signing).
 */
export function ConsentWordingPreview({
  wording,
  label = 'Preview language',
}: {
  wording: ConsentWording;
  label?: string;
}) {
  const [lang, setLang] = useState<WordingLang>('en');
  const text = (s: string) =>
    s.trim() ? <p>{s}</p> : <p className={styles.empty}>Not written yet</p>;
  return (
    <div>
      <Tabs
        label={label}
        value={lang}
        onChange={setLang}
        items={LANGS.map((l) => ({ value: l, label: LANG_LABEL[l] }))}
      />
      <article
        className={styles.preview}
        lang={lang}
        aria-label={`Preview in ${LANG_LABEL[lang]}`}
      >
        <h3>
          {wording.title[lang].trim() || (
            <span className={styles.empty}>No title yet</span>
          )}
        </h3>
        {WORDING_SECTIONS.map((s) => (
          <section key={s}>
            <h4>{SECTION_HEADING[lang][s]}</h4>
            {text(wording[s][lang])}
          </section>
        ))}
      </article>
    </div>
  );
}
